export const getTargetApp = (path) => {
  if (!path) return undefined;
  const normalized = path[0] === "/" ? path : "/" + path;
  const pathArray = normalized.split("/");
  if (pathArray[1] === "app" || pathArray[1] === "account-app") {
    return pathArray[2]?.split("?")[0];
  }
  return undefined;
};

export const getTargetAppPath = (path) => {
  if (!path) return undefined;
  const normalized = path[0] === "/" ? path : "/" + path;
  const pathArray = normalized.split("?");
  if (pathArray.length > 1) {
    const paramsArray = pathArray[1].split("=");
    return paramsArray[1];
  }
  return undefined;
};

export const getCurrentApp = () => {
  const pathArray = window.location.pathname.split("/");
  if (pathArray[1] === "app" || pathArray[1] === "account-app") {
    return pathArray[2];
  }
  return undefined;
};

export const resolveNavItemTarget = (item) => {
  const targetApp = getTargetApp(item.path);
  const targetAppPath = getTargetAppPath(item.path);
  const currentApp = getCurrentApp();
  const isShallow = !!targetApp && targetApp === currentApp;
  return { targetApp, targetAppPath, currentApp, isShallow };
};

export const shallowNavigateInIframe = (item, targetAppPath) => {
  const iframe = document.getElementById("app-iframe");
  iframe?.contentWindow?.postMessage(
    {
      type: "navigate",
      payload: { path: targetAppPath },
    },
    "*"
  );
  window.history.pushState(undefined, undefined, item.path);
};

export const navigateToNavItem = (item, { navigate }) => {
  const { isShallow, targetAppPath } = resolveNavItemTarget(item);
  if (isShallow) {
    shallowNavigateInIframe(item, targetAppPath);
  } else {
    navigate(item.path);
  }
};
